import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Modal,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Colors } from '../utils/Colors';
import { HomeworkTrial } from '../utils/Homework';

export function ErpTrialRow({
  trial,
  idx,
  onChange,
  onTrialUpdate
}: {
  trial: HomeworkTrial;
  idx: number;
  onChange: (event: any, trialId: string) => void;
  onTrialUpdate: (trialId: string) => void;
}) {
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);

  const handleOpenNotesModal = () => setShowNotesModal(true);
  const handleCloseNotesModal = () => setShowNotesModal(false);

  const checkRequiredFields = () => {
    const hasSubmittedSeconds =
      !!trial.submittedSeconds && trial.submittedSeconds > 0;
    const hasStartingAnxiety =
      !!trial.startingAnxiety && trial.startingAnxiety > 0;
    const hasEndingAnxiety = !!trial.endingAnxiety && trial.endingAnxiety > 0;

    setIsSaveEnabled(
      hasSubmittedSeconds && hasStartingAnxiety && hasEndingAnxiety
    );
  };

  useEffect(() => {
    checkRequiredFields(); // Check initially when the component mounts
  }, [trial]);

  const handleChange = (event: any, trialId: string) => {
    onChange(event, trialId);
    checkRequiredFields(); // Check after each field change
  };

  return (
    <TableRow
      key={trial.id}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems="center">
          <Typography sx={{ mr: 1 }}>{idx + 1}</Typography>
          {trial.submittedSeconds &&
            trial.submittedSeconds >= trial.goalSeconds && <CheckCircleIcon />}
        </Box>
      </TableCell>
      <TableCell component="th" scope="row">
        {trial.goalSeconds}
      </TableCell>
      <TableCell component="th" scope="row">
        <TextField
          id="submittedSeconds"
          value={trial.submittedSeconds || ''}
          size="small"
          type="tel"
          onChange={(event) => handleChange(event, trial.id)}
          error={!trial.submittedSeconds || trial.submittedSeconds <= 0}
          helperText={
            !trial.submittedSeconds || trial.submittedSeconds <= 0
              ? 'Required'
              : ''
          }
        />
      </TableCell>
      {/* <TableCell component="th" scope="row">
        {trial.submittedSeconds && trial.submittedSeconds >= trial.goalSeconds
          ? 'Completed'
          : 'Incomplete'}
      </TableCell> */}
      <TableCell component="th" scope="row">
        <TextField
          id="startingAnxiety"
          value={trial.startingAnxiety || ''}
          size="small"
          type="tel"
          onChange={(event) => handleChange(event, trial.id)}
          error={!trial.startingAnxiety || trial.startingAnxiety <= 0}
          helperText={
            !trial.startingAnxiety || trial.startingAnxiety <= 0
              ? 'Required'
              : ''
          }
        />
      </TableCell>
      <TableCell component="th" scope="row">
        <TextField
          id="endingAnxiety"
          value={trial.endingAnxiety || ''}
          size="small"
          type="tel"
          onChange={(event) => handleChange(event, trial.id)}
          error={!trial.endingAnxiety || trial.endingAnxiety <= 0}
          helperText={
            !trial.endingAnxiety || trial.endingAnxiety <= 0 ? 'Required' : ''
          }
        />
      </TableCell>
      <TableCell component="th" scope="row">
        <Button style={{ color: '#010d0d' }} onClick={handleOpenNotesModal}>
          <Edit />
        </Button>
      </TableCell>
      <TableCell component="th" scope="row">
        <Button
          color="inherit"
          style={{
            padding: '5px 20px',
            color: '#010d0d',
            borderRadius: 30,
            fontSize: '20px',
            backgroundColor: Colors.ocdGreen
          }}
          disabled={!isSaveEnabled} // Disable the button if not all fields are filled
          onClick={() => isSaveEnabled && onTrialUpdate(trial.id)} // Call onTrialUpdate only if enabled
        >
          <Typography style={{ color: Colors.ocdWhite }}>Save</Typography>
        </Button>
      </TableCell>
      <Modal open={showNotesModal} onClose={handleCloseNotesModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            p: 4
          }}
        >
          <Typography variant="h6" component="h2">
            Edit Notes
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            id="notes"
            value={trial.notes || ''}
            onChange={(event) => handleChange(event, trial.id)}
            sx={{ mt: 2 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              style={{
                padding: '5px 20px',
                color: '#010d0d',
                borderRadius: 30,
                fontSize: '20px',
                backgroundColor: Colors.ocdGreen
              }}
              onClick={handleCloseNotesModal}
              color="inherit"
              sx={{ mt: 3 }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </TableRow>
  );
}
